import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const MAX = 500;

export const LimitEditor = ({ u, onSave }) => {
  const [value, setValue] = useState(String(u.project_limit));
  const [saving, setSaving] = useState(false);
  useEffect(() => setValue(String(u.project_limit)), [u.project_limit]);

  const n = Number(value);
  const valid = value !== "" && Number.isInteger(n) && n >= 0 && n <= MAX;
  const changed = valid && n !== u.project_limit;

  const save = async (e) => {
    e.preventDefault();
    if (!changed) return;
    setSaving(true);
    const ok = await onSave(n);
    setSaving(false);
    if (!ok) setValue(String(u.project_limit));
  };

  return (
    <form onSubmit={save} className="flex items-center gap-2">
      <Input
        type="number" min={0} max={MAX} step={1} value={value}
        onChange={(e) => setValue(e.target.value)}
        className="h-9 w-20 rounded-full text-center"
        aria-label={`Project limit for ${u.email}`}
        data-testid={`admin-limit-input-${u.user_id}`}
      />
      <Button type="submit" size="sm" variant={changed ? "default" : "outline"} className="rounded-full" disabled={!changed || saving} data-testid={`admin-limit-save-${u.user_id}`}>
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save"}
      </Button>
    </form>
  );
};
